(function ($, DGS, moment) {
  DGS.OnLoad.getInstance().register(function () {
    $('.blog--two-col .component.related-blogs').each(function () {
      var $rteBefore = $(this).prev('.component.rich-text'),
        $thisColumn = $(this).parent("[class*='section']");
      $(this).addClass('component-ready animate');
      $rteBefore.addClass('component-ready animate');
      $rteBefore.addClass('related-blogs-header');
      $thisColumn.addClass('section-with-header');
      $('li', $(this)).each(function () {
        // Now change the date format
        var $newsDate = $('.news-date', $(this));
        if ($newsDate.length > 0 && $newsDate.html() !== '') {
          var momentDate = moment($newsDate.html(), 'DD/MM/YY'); // This is the format of sitecore
          $newsDate.html(momentDate.format('D MMMM YYYY'));
        }
        $newsDate.insertAfter($('.news-title', $(this)));
      });
    });
  });
})(jQuery, window.DGS, window.moment);